import { css } from '@emotion/react';

import useTheme from '../../hooks/useTheme';

export default () => {
  const { breakpoints, colors } = useTheme();
  const commonTextStyles = css`
    font-family: FS Dillon;
    text-align: left;
    color: ${colors.white};
  `;
  return {
    CFAContactCountyBNRCont: css`
      background: ${colors.red} url('/images/desktop/recommendations/CFAOpenFiltersBNRDesktop.svg') no-repeat center center;
      background-size: cover;
      overflow: hidden;
      min-height: 11.25rem;
      padding: 1.875rem 5rem;
      margin: 5rem 0 1.5rem;
      display: flex;
      align-items: center;
      justify-content: space-between;
      ${breakpoints.mm_l_xl} {
        margin-top: 2.5rem;
        padding: 1.875rem 5rem;
        min-height: 13.75rem;
      }
      ${breakpoints.mm_m_l} {
        margin-top: 2.5rem;
        padding: 1.875rem 5rem;
        min-height: 15.625rem;
      }
      ${breakpoints.mm_s_m} {
        margin-top: 2.5rem;
        min-height: 12.5rem;
        padding: 1.875rem 2.5rem;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
      }
      ${breakpoints.mm_xs_s} {
        margin-top: 2.5rem;
        background: ${colors.red} url('/images/mobile/recommendations/CFAOpenFiltersBNRMobile.svg') no-repeat center center;
        background-size: cover;
        overflow: hidden;
        min-height: 19.125rem;
        padding: 1.875rem 2.5rem;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
      }
      ${breakpoints.mm_xxs_xs} {
        margin-top: 2.5rem;
        background: ${colors.red} url('/images/mobile/recommendations/CFAOpenFiltersBNRMobile.svg') no-repeat center center;
        background-size: cover;
        overflow: hidden;
        min-height: 19.125rem;
        padding: 1.875rem 0.75rem;
        flex-direction: column;
        align-items: flex-start;
        justify-content: center;
      }
    `,
    CFABannerText: css`
      ${breakpoints.mm_l_xl} {
        max-width: 34.375rem;
      }
      ${breakpoints.mm_m_l} {
        max-width: 25rem;
      }
      @media (min-width: 770px) and (max-width: 860px) {
        max-width: 22rem;
      }
      ${breakpoints.mm_s_m} {
        max-width: 80%;
      }
    `,
    CFACCTitle: css`
      ${commonTextStyles};
      font-weight: 700;
      font-size: 3rem;
      line-height: 3.563rem;
      letter-spacing: -1%;
      ${breakpoints.mm_m_l} {
        font-size: 1.944rem;
        line-height: 2rem;
      }
      ${breakpoints.mm_s_m} {
        font-size: 1.944rem;
        line-height: 2rem;
      }
      ${breakpoints.mm_xs_s} {
        font-size: 1.944rem;
        line-height: 2.5rem;
        letter-spacing: 0.16px;
      }
      ${breakpoints.mm_xxs_xs} {
        font-size: 1.944rem;
        line-height: 2rem;
        letter-spacing: 0.16px;
      }
    `,
    CFACCSubTitle: css`
      ${commonTextStyles};
      font-size: 1.125rem;
      font-weight: 400;
      line-height: 1.5rem;
      letter-spacing: 2%;
      margin-top: 0.5rem;
      ${breakpoints.mm_s_m} {
        line-height: 1.3rem;
        margin: 1rem 0 0.75rem;
      }
      ${breakpoints.mm_xs_s} {
        font-size: 1.125rem;
        line-height: 1.3rem;
        margin: 1rem 0 1rem;
      }
      ${breakpoints.mm_xxs_xs} {
        font-size: 1.125rem;
        line-height: 1.3rem;
        margin: 1rem 0 2rem;
      }
    `,
    CFACCButton: css`
      transition: all 0.3s ease;
      background: ${colors.white};
      text-decoration: none;
      cursor: pointer;
      padding: 0.875rem 4.25rem;
      outline: none;
      border: none;
      border-radius: 4px;
      font-family: FS Dillon;
      font-size: 1rem;
      letter-spacing: 2%;
      line-height: 1.25rem;
      font-weight: 400;
      max-width: 19.438rem;
      text-align: center;
      color: ${colors.black};
      &:hover,
      &:focus,
      &:active {
        outline: 2px solid ${colors.next_grey};
        color: ${colors.navy};
      }
      &:focus-visible:not(:hover) {
        border: 2px solid ${colors.border_black};
        color: ${colors.border_black};
        background-color: ${colors.skip_yellow};
        text-decoration: underline;
        text-decoration-color: ${colors.border_black};
        outline: none;
      }
      @media (min-width: 770px) and (max-width: 860px) {
        padding: 0.875rem 2.5rem;
        font-size: 0.875rem;
      }
      ${breakpoints.mm_s_m} {
        margin: 1rem 0 0;
        font-size: 0.875rem;
      }
      ${breakpoints.mm_xs_s} {
        margin: 1rem 0 0;
        font-size: 0.875rem;
      }
      @media (min-width: 375px) and (max-width: 440px) {
        align-self: center;
      }
      @media (min-width: 351px) and (max-width: 380px) {
        padding: 0.875rem 2.25rem;
        min-width: 100%;
      }
      ${breakpoints.mm_xxs_xs} {
        font-size: 0.875rem;
        min-width: 100%;
        align-self: center;
        padding: 0.875rem 2.25rem;
      }
    `,
  };
};
